import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { PhoneApp } from '@tixo/ui'
import { installUx } from './ux'

/// Stretches the marketing 268×580 PhoneApp layout edge-to-edge on the
/// real iPhone via a non-uniform scale transform. iPhone 13 mini's
/// logical viewport (375×812) has the exact same 0.462 aspect ratio,
/// so the stretch is uniform on that device; other phones get a tiny
/// non-uniform component handling aspect drift.
///
/// We expose the INVERSE of each scale axis as a CSS custom property
/// so the inner CSS can express safe-area padding directly via
/// `calc(env(safe-area-inset-*) * var(--phs-inv-y))`. That lets the
/// padding land at the correct visual size on the device regardless
/// of how stretched the mockup viewport is — no JS probe required.
export function App() {
  const stageRef = useRef<HTMLDivElement>(null)
  const [{ sx, sy }, setScale] = useState({ sx: 1, sy: 1 })

  useEffect(() => { installUx() }, [])

  useLayoutEffect(() => {
    function fit() {
      const W = 268
      const H = 580
      setScale({
        sx: window.innerWidth / W,
        sy: window.innerHeight / H,
      })
    }
    fit()
    window.addEventListener('resize', fit)
    window.addEventListener('orientationchange', fit)
    return () => {
      window.removeEventListener('resize', fit)
      window.removeEventListener('orientationchange', fit)
    }
  }, [])

  return (
    <div
      ref={stageRef}
      className="app-stage"
      style={{
        ['--phs-scale-x' as never]: sx,
        ['--phs-scale-y' as never]: sy,
        ['--phs-inv-x' as never]: 1 / Math.max(sx, 0.001),
        ['--phs-inv-y' as never]: 1 / Math.max(sy, 0.001),
      }}
    >
      <PhoneApp initialTab="home" />
    </div>
  )
}
